import { Grid } from '@mui/material';
import { Box } from '@mui/material';
import React from 'react';
import WhisperInterest from './HomePage/WhisperInterest';
import TopOpportunity from './HomePage/TopOpportunity';
import PerformanceReview from './HomePage/PerformanceReview';
import Accounts from './HomePage/Accounts';

export default function HomePage({ mode, height }: { mode: string, height: number }){
    const [theme, setTheme] = React.useState(mode);
    React.useEffect(() => {
        setTheme(mode);
    }, [mode]);
    return (
        <Box style={{ maxWidth: '100% !important' }}>
            <Grid container spacing={1} sx ={{ sm: 2, md: 3, lg: 4, xl: 4 }} >
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
                    <TopOpportunity mode={theme} height={600} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
                    <PerformanceReview mode={theme} height={height} title='Performance Review' />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
                    <WhisperInterest mode={theme} height={600} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
                    <Accounts theme={theme} height={600} fullFeatured={false} pageSize={10}/>
                </Grid>
            </Grid>
        </Box>
    );
}   